import { Injectable } from "@angular/core";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { CapturedField } from "./dtos";

@Injectable({ providedIn: 'root' })
export class UtilService {
	dataURItoBlob(dataURI) {
		// convert base64 to raw binary data held in a string
		// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
		var byteString = atob(dataURI.split(',')[1]);

		// separate out the mime component
		var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

		// write the bytes of the string to an ArrayBuffer
		var ab = new ArrayBuffer(byteString.length);
		var ia = new Uint8Array(ab);
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}

		//Old Code
		//write the ArrayBuffer to a blob, and you're done
		//var bb = new BlobBuilder();
		//bb.append(ab);
		//return bb.getBlob(mimeString);

		//New Code
		return new Blob([ab], { type: mimeString });
	}

	dataUrlToFile(dataUrl: string, filename: string): File | undefined {

		return new File([new Blob([dataUrl])], filename);

		// const arr = dataUrl.split(',');
		// if (arr.length < 2) { return undefined; }
		// const mimeArr = arr[0].match(/:(.*?);/);
		// if (!mimeArr || mimeArr.length < 2) { return undefined; }
		// const mime = mimeArr[1];
		// const buff = Buffer.from(arr[1], 'base64');
		// return new File([buff], filename, {type:mime});
	}

	base64ToArrayBuffer(base64) {
		var binary_string = atob(base64.split(',')[1]);
		// var binary_string = window.atob(base64);
		var len = binary_string.length;
		var bytes = new Uint8Array(len);
		for (var i = 0; i < len; i++) {
			bytes[i] = binary_string.charCodeAt(i);
		}
		return bytes.buffer;
	}

	base64ToBlob(b64Data: any, contentType: string) {

		
		contentType = contentType || "";
		const sliceSize = 512;

		var byteCharacters = atob(b64Data.split(',')[1]);
		var byteArrays = [];

		for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			var slice = byteCharacters.slice(offset, offset + sliceSize);

			var byteNumbers = new Array(slice.length);
			for (var i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			var byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}

		console.log(byteArrays);

		return new File(byteArrays, "pot", { type: contentType });
	}

	parseDate(date: any) {
		console.log('Parsing date', date);
		if (date === null) {
			return undefined;
		}
		if (date instanceof NgbDate) {
			if (date.year === -1 || date.year === null) {
				return undefined;
			}
			var d = new Date();
			d.setFullYear(date.year);
			d.setUTCMonth(date.month - 1);
			d.setDate(date.day);
			console.log('Returning NgbDate: ', d.getFullYear() + '-' + d.getUTCMonth() + '-' + d.getDate());

			return this.formatDate(d);
		} else if (typeof date === 'string') {
			var d: Date = null;
			if (this.isSlashDateFormat(date)) {
				d = this.parseSlashDate(date)	
			} else {
				d = new Date(date);
			}
			console.log('Returning Date: ', d.getFullYear() + '-' + (d.getUTCMonth() + 1) + '-' + d.getDate());
			return this.formatDate(d);
		} else {
			try {
				var d = new Date();
				d.setFullYear(date.year);
				d.setUTCMonth(date.month - 1);
				d.setDate(date.day);

				return this.formatDate(d);
			} catch (e) {
				console.log("Failed to extract date from NgbDate");
				console.log(e);
			}
		}
	}
	private formatDate(d: Date): string {
		const day = String(d.getDate()).padStart(2, '0');
		const month = String(d.getMonth() + 1).padStart(2, '0'); // getMonth() is 0-based
		const year = d.getFullYear();

		return `${day}/${month}/${year}`;
	}
	private parseSlashDate(str): Date {
		const [day, month, year] = str.split('/').map(Number);
		return new Date(year, month - 1, day); // Month is 0-based in JS
	}
	private isSlashDateFormat(str) {
  		const regex = /^([1-9]|0[1-9]|[12][0-9]|3[01])\/([1-9]|0[1-9]|1[0-2])\/\d{4}$/;
  		return regex.test(str);
	}

	parsePossibleBoolean(value: any) {
		if (value === true || value === 'true') {
			return 'Yes';
		}
		if (value === false  || value === 'false') {
			return 'No';
		}
		return value;
	}
}

